<template lang="pug">
    div.cart-button-control
        router-link(:to="{ name: 'shopping-cart-page' }")
            svg-icon(iconId="shopping-cart")
            div.cart-button-control__counter(v-if="visibleCartItemsCount")
                span {{ visibleCartItemsCount }}
</template>

<script>
import ReMiniCart from 'utils/vue/components/complex/cart/re-mini-cart/script.js'

export default {
    name: 'cart-button-control',
    mixins: [
        ReMiniCart,
    ],
}
</script>
